(function () {
  'use strict';

  var CORE_GUARD = [
    'global.js',
    'constants.js',
    'pubsub.js',
    'theme.js',
    'jquery',
    'cs-theme.js',
    'cs-product.js',
    'cs-collection.js',
    'product-info.js',
    'product-form.js',
    'media-gallery.js',
    'details-disclosure.js',
    'details-modal.js',
    'search-form.js',
    'cart-drawer.js',
    'predictive-search.js'
  ];

  var loaded = false;
  var queue = [];
  var fallbackTimer;

  function isCoreScript(src) {
    if (!src) return true;
    return CORE_GUARD.some(function (key) {
      return src.indexOf(key) !== -1;
    });
  }

  window.csDeferScript = function (cfg) {
    if (!cfg || !cfg.src || isCoreScript(cfg.src)) return;
    queue.push(cfg);
  };

  function injectScript(cfg) {
    if (cfg.id && document.getElementById(cfg.id)) return;

    var script = document.createElement('script');
    script.id = cfg.id;
    script.src = cfg.src;
    script.async = true;
    if (cfg.type) script.type = cfg.type;

    if (cfg.dataset) {
      Object.keys(cfg.dataset).forEach(function (key) {
        script.dataset[key] = cfg.dataset[key];
      });
    }

    document.body.appendChild(script);
  }

  function flush() {
    if (loaded) return;
    loaded = true;
    queue.forEach(injectScript);
    events.forEach(function (eventName) {
      window.removeEventListener(eventName, flush, listenerOpts);
    });
    if (fallbackTimer) clearTimeout(fallbackTimer);
  }

  var events = ['mousemove', 'scroll', 'touchstart', 'keydown', 'click'];
  var listenerOpts = { passive: true, once: true };
  events.forEach(function (eventName) {
    window.addEventListener(eventName, flush, listenerOpts);
  });

  fallbackTimer = setTimeout(flush, 5000);
})();
